import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class AnomalieZoneEvent extends UserEvent {
  public static NAME = 'ANOMALIE_ZONE';

  constructor(
    public idVacation: string | undefined,
    public idZone: string,
    public texte: string | undefined,
    public photos: string[],
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(AnomalieZoneEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: AnomalieZoneEvent): AnomalieZoneEvent {
    return new AnomalieZoneEvent(obj.idVacation, obj.idZone, obj.texte, obj.photos, dayjs(obj.instant), obj.coordinates);
  }
}
